export default __webpack_public_path__ + "static/media/hotspot-inner-yellow.d6d79c93.svg";